import { FC, SVGProps } from "react";

const RadiantLogo: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      opacity="0.5"
      d="M15.3973 0V32C14.6656 31.9662 13.9517 31.8969 13.2458 31.7679V18.7204L7.38437 24.5818L5.86141 23.0588L11.8775 17.0427H0.0338472C0.00806156 16.6978 0 16.3546 0 16.0016C0 15.6487 0.00806117 15.2619 0.0435164 14.8912H11.8775L5.86141 8.86704L7.38437 7.35213L13.2458 13.2135V0.232071L15.3973 0Z"
      fill="currentColor"
    />
    <path
      d="M22.5665 17.0412L31.3192 20.656C31.1209 21.3538 30.8631 22.0242 30.5617 22.6705L21.6367 18.9864L28.5649 25.9147C28.1346 26.4819 27.6528 27.017 27.1274 27.515L20.0089 20.3965L23.735 30.0275C23.1064 30.3723 22.4521 30.6737 21.772 30.9316L17.4336 19.7084C19.1032 19.27 20.3345 17.7551 20.3345 15.9469C20.3345 14.1387 19.1032 12.6334 17.4336 12.1935L21.7462 1.05566C22.4183 1.30546 23.071 1.60683 23.6995 1.9501L20.0073 11.5037L27.0742 4.43681C27.5996 4.92674 28.0815 5.46179 28.5295 6.02102L21.635 12.9155L30.5263 9.24906C30.8276 9.89531 31.0855 10.5657 31.3014 11.2539L22.4972 14.8864H31.9735L31.9815 17.0379H22.5649L22.5665 17.0412Z"
      fill="currentColor"
    />
  </svg>
);

export default RadiantLogo;
